import { MutableRefObject, useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';

import { getVerifyCodeForLoginByPhoneNumber, setTimeIsEnd } from '../../../../model/slice/authSlice';
import cls from './Timer.module.scss';

const calculateTimeLeft = (timestamp: number) => {
  const now = new Date().getTime();
  const distance = timestamp - now;

  return {
    seconds: Math.floor((distance % (1000 * 60)) / 1000)
  };
};

export const Timer = () => {
  const dispatch = useAppDispatch();
  const timestamp = useAppSelector((state) => state.auth.verifyCode.codeSendingTime);
  const timeIsEnd = useAppSelector((state) => state.auth.verifyCode.timeIsEnd);
  const isLoading = useAppSelector((state) => state.auth.isLoading);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(timestamp));

  const timerRef = useRef() as MutableRefObject<ReturnType<typeof setTimeout>>;

  const refreshCode = () => {
    if (isLoading) return;

    dispatch(getVerifyCodeForLoginByPhoneNumber());
  };

  useEffect(() => {
    timerRef.current = setInterval(() => {
      const currentTime = new Date().getTime();
      if (timestamp > currentTime + 1000) {
        setTimeLeft(calculateTimeLeft(timestamp));
      } else {
        setTimeLeft({ seconds: 59 });
        dispatch(setTimeIsEnd(true));
        clearInterval(timerRef.current);
      }
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [dispatch, timestamp]);

  return (
    <div className={cls.wrap}>
      {timeIsEnd ? (
        <button
          onClick={refreshCode}
          className={cls.button}
        >
          Отправить повторный код на телефон
        </button>
      ) : (
        <div
          data-testid={'timer-text'}
          className={cls.text}
        >
          Проверочный код можно отправить <br /> через {timeLeft.seconds} секунд
        </div>
      )}
    </div>
  );
};
